var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":""},on:{"enter":_vm.enter,"leave":_vm.leave}},[(_vm.game.showProgress)?_c('div',{key:_vm.game.showProgress,staticClass:"game__footer"},[_c('GameCounter'),_c('GameNextButton')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }